import {Controller} from "@hotwired/stimulus"
import Slideout from "slideout"
import screen from "screen"
import {updateIcon} from "../dom_utils"

class SlideoutController extends Controller {
  static targets = ["menu", "panel", "topbarMobile", "menuEntry"]

  connect() {
    if (screen.isMdScreen()) {
      this.createSlideout()
      return
    }

    screen.onMdScreen(e => {
      if (e.matches) this.createSlideout()
    })
  }

  disconnect() {
    this.slideout?.destroy()
  }

  toggle() {
    this.slideout?.toggle()
  }

  toggleMenuEntry(e) {
    const target = e.currentTarget
    const menuEntry = target.closest("[data-slideout-target='menuEntry']")
    const isOpen = menuEntry.classList.contains("opened")
    this.closeAllMenuEntries()
    if (isOpen) return

    menuEntry.classList.add("opened")
    updateIcon(target, "fa-caret-down")
  }

  closeAllMenuEntries() {
    for (const menuEntry of this.menuEntryTargets) {
      menuEntry.classList.remove("opened")
      const icon = menuEntry.querySelector(".nav-mobile__title > svg")
      updateIcon(icon, "fa-caret-right")
    }
  }

  createSlideout() {
    if (this.slideout) return
    if (!this.hasMenuTarget) return

    this.slideout = new Slideout({
      panel: this.panelTarget,
      menu: this.menuTarget,
      side: "right",
      duration: 0,
      // enabling this creates an error on ie when scrolling because the
      // decouple library used by slideout has a problem with
      // window.requestAnimationFrame
      // https://github.com/pazguille/decouple/blob/master/index.js#L4
      touch: false
    })

    this.slideout.on("translate", translated => {
      this.topbarMobileTarget.style.transform = `translateX(${translated}px)`
    })

    this.slideout.on("beforeopen", () => {
      this.topbarMobileTarget.style.transform = "translateX(-256px)"
      this.topbarMobileTarget.style.transition = "transform 300ms ease"
    })

    this.slideout.on("beforeclose", () => {
      this.topbarMobileTarget.style.transition = "transform 300ms ease"
      this.topbarMobileTarget.style.transform = ""
    })

    this.slideout.on("open", () => {
      this.topbarMobileTarget.style.transition = ""
    })
    this.slideout.on("close", () => {
      this.topbarMobileTarget.style.transition = ""
    })
  }
}

export default SlideoutController
